module.exports = __webpack_public_path__ + "img/image_004.84d1c359.png";